import React, {
  CSSProperties,
  FC, useRef,
} from 'react';
import {
  ButtonDiv, Column,
} from './Styles';

const Button: FC<Props> = ({
  children,
  callback,
  style,
}) => {
  const btnRef = useRef<any>();

  return (
    <Column>
      <ButtonDiv
        ref={btnRef}
        style={{ ...style }}
        onClick={() => {
          // 触发点击回调
          callback();

          try {
            if (btnRef.current && btnRef.current.style) {
              btnRef.current.style.transform = `scale(0.9)`;
            }
            setTimeout(() => {
              if (btnRef.current && btnRef.current.style) {
                btnRef.current.style.transform = `scale(1)`;
              }
            }, 50);
          } catch (e) {
            console.error(e);
          }
        }}
      >
        {children}
      </ButtonDiv>

      {/* 顶层div，点击后触发按钮点击，增加按钮的点击响应区域 */}
      <div
        onClick={() => {
          btnRef.current.click();
        }}
        style={{ height: 73, width: '100%', marginTop: -55 }}
      />
    </Column>
  );
};

export interface Props {
  children: any;
  callback: () => void;
  showAnimation?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

export default Button;
